import { render, staticRenderFns } from "./CommunityCard.vue?vue&type=template&id=d92eab4c&scoped=true"
import script from "./CommunityCard.vue?vue&type=script&lang=js"
export * from "./CommunityCard.vue?vue&type=script&lang=js"
import style0 from "./CommunityCard.vue?vue&type=style&index=0&id=d92eab4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92eab4c",
  null
  
)

export default component.exports